import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { createPortal } from "react-dom";

import { ApiError, getHealth, type Health } from "@/lib/api";

/** El servidor identifica su modo incluso sin sesión. Nunca elige API ni base. */
export function BandaEnsayo() {
  const query = useQuery({
    queryKey: ["health"],
    queryFn: ({ signal }) => getHealth({ signal }),
    retry: false,
    staleTime: Infinity,
  });
  const health = query.data ?? (query.error instanceof ApiError && query.error.status === 503
    ? query.error.body as Health | null : null);
  const practice = health?.practice === true;

  useEffect(() => {
    if (!practice) return;
    document.body.dataset.practice = "true";
    const prefix = "ENSAYO · ";
    const markTitle = () => {
      if (!document.title.startsWith(prefix)) document.title = prefix + document.title;
    };
    markTitle();
    // Sigue los títulos de navegación sin volver a escribir su propia modificación.
    const observer = new MutationObserver(markTitle);
    observer.observe(document.head, { subtree: true, childList: true, characterData: true });
    return () => {
      observer.disconnect();
      delete document.body.dataset.practice;
      if (document.title.startsWith(prefix)) document.title = document.title.slice(prefix.length);
    };
  }, [practice]);

  return practice ? createPortal(<div className="practice-band" role="status">ENSAYO</div>, document.body) : null;
}
